import { useTranslation } from 'react-i18next';
import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { Button } from '../../ui/button';
import { AlertTriangle, Save, Loader2 } from 'lucide-react';

const UnsavedChangesWarning = ({ saving, onSave }) => {
  const { t } = useTranslation();
  return (
    <Card className="border-amber-300 bg-amber-50">
      <CardContent className="py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-amber-800">
            <AlertTriangle className="h-5 w-5" />
            <span className="font-medium">{t('auto.ctr.youHaveUnsavedChanges')}</span>
          </div>
          <Button onClick={onSave} disabled={saving} size="sm" data-testid="btn-save">
            {saving ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Save className="h-4 w-4 mr-2" />}
            Save Now
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default UnsavedChangesWarning;
